export const shouldOpenModal = (
  routerIsReady: boolean,
  loginQuery: string | string[],
  isLoading: boolean,
  isLoggedIn: boolean
): boolean => {
  return routerIsReady && !isLoading
    ? !isLoggedIn && loginQuery === 'true'
    : false
}
